export default __webpack_public_path__ + "static/media/govt-logo.456cabd8.png";